module.exports = __webpack_public_path__ + "static/media/by.642e4a1a.png";